export enum AnnualReportType {
  AccountingPackage = 'accountingPackage',
  CompletePlan = 'completePlan',
  DIY = 'diy',
}
